import React from "react";
import classNames from "classnames";
import { Box } from "fds";

export interface IProps {
  borderRadius?: string | number;
  color?: "black" | "color" | "none";
  size: "sm" | "md" | "lg" | "empty";
  stroke?: string;
  classes?: string;
  width?: string | number | undefined;
  height?: string | number | undefined;
}
const AIChatIconMenu: React.FC<IProps> = ({
  classes,
  borderRadius,
  color = "color",
  size = "sm",
  stroke,
  width,
  height,
}) => {
  return size !== "empty" ? (
    <Box
      style={{ borderRadius: borderRadius }}
      classes={classNames("icon-root AIChatIconMenu", classes, color, size)}
    >
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.4561 3.54394C17.1813 4.2692 17.1813 5.44508 16.4561 6.17034L6.17034 16.4561C5.44508 17.1813 4.2692 17.1813 3.54394 16.4561C2.81869 15.7308 2.81869 14.5549 3.54394 13.8297L13.8297 3.54394C14.5549 2.81869 15.7308 2.81869 16.4561 3.54394Z"
          fill={stroke || "white"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.1703 19.8297C24.8956 20.5549 24.8956 21.7308 24.1703 22.456L18.1703 28.4561C17.4451 29.1813 16.2692 29.1813 15.5439 28.4561C14.8187 27.7308 14.8187 26.5549 15.5439 25.8297L21.544 19.8297C22.2692 19.1044 23.4451 19.1044 24.1703 19.8297Z"
          fill={stroke || "white"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.5994 4.40118C28.3247 5.12644 28.3247 6.30232 27.5994 7.02758L12.1708 22.4562C11.4456 23.1814 10.2697 23.1814 9.54443 22.4562C8.81917 21.7309 8.81917 20.555 9.54443 19.8298L24.973 4.40118C25.6983 3.67592 26.8742 3.67592 27.5994 4.40118Z"
          fill={stroke || "white"}
        />
      </svg>
    </Box>
  ) : (
    <svg
      className={classNames("icon-root", classes)}
      width={width || "32px"}
      height={height || "32px"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.4561 3.54394C17.1813 4.2692 17.1813 5.44508 16.4561 6.17034L6.17034 16.4561C5.44508 17.1813 4.2692 17.1813 3.54394 16.4561C2.81869 15.7308 2.81869 14.5549 3.54394 13.8297L13.8297 3.54394C14.5549 2.81869 15.7308 2.81869 16.4561 3.54394Z"
        fill={stroke || "white"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.1703 19.8297C24.8956 20.5549 24.8956 21.7308 24.1703 22.456L18.1703 28.4561C17.4451 29.1813 16.2692 29.1813 15.5439 28.4561C14.8187 27.7308 14.8187 26.5549 15.5439 25.8297L21.544 19.8297C22.2692 19.1044 23.4451 19.1044 24.1703 19.8297Z"
        fill={stroke || "white"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.5994 4.40118C28.3247 5.12644 28.3247 6.30232 27.5994 7.02758L12.1708 22.4562C11.4456 23.1814 10.2697 23.1814 9.54443 22.4562C8.81917 21.7309 8.81917 20.555 9.54443 19.8298L24.973 4.40118C25.6983 3.67592 26.8742 3.67592 27.5994 4.40118Z"
        fill={stroke || "white"}
      />
    </svg>
  );
};

export default AIChatIconMenu;
